"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MareNectarisMine = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const MoonSpaces_1 = require("../../moon/MoonSpaces");
const Units_1 = require("../../Units");
const TileType_1 = require("../../TileType");
const MoonCard_1 = require("./MoonCard");
const CardRenderItem_1 = require("../render/CardRenderItem");
const Card_1 = require("../Card");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
class MareNectarisMine extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.MARE_NECTARIS_MINE,
            cardType: CardType_1.CardType.AUTOMATED,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            cost: 14,
            productionBox: Units_1.Units.of({ steel: 1 }),
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            tr: { moonMining: 1 },
            metadata: {
                description: 'Spend 1 titanium. Increase your steel production 1 step. Place a mine ON THE RESERVED AREA and raise the Mining Rate 1 step.',
                cardNumber: 'M01',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().titanium(1).nbsp();
                    b.production((pb) => pb.steel(1));
                    b.moonMine().secondaryTag(CardRenderItem_1.AltSecondaryTag.MOON_MINING_RATE).asterix();
                }),
            },
        }, {
            tilesBuilt: [TileType_1.TileType.MOON_MINE],
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, true, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        super.play(player);
        MoonExpansion_1.MoonExpansion.addMineTile(player, MoonSpaces_1.MoonSpaces.MARE_NECTARIS, this.name);
        MoonExpansion_1.MoonExpansion.raiseMiningRate(player);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonMiningRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.MareNectarisMine = MareNectarisMine;
//# sourceMappingURL=MareNectarisMine.js.map